import React from 'react';
import "./style.css";

const ThankYou = () => {
  return (
    <div className="thank-you-container">
      <div className="thank-you-message">
        <h2>Vielen Dank!</h2>
        <p>Ihre Nachricht wurde erfolgreich gesendet.</p>
        <p>Ich werde mich so schnell wie möglich bei Ihnen melden.</p>
        <a href="/" className="btn btn-outline">Zurück zur Startseite</a>
      </div>
    </div>
  );
};

export default ThankYou; 